import React from 'react';
import loadable from '@loadable/component';
import styles from './Navbar.scss';
import cx from 'classnames';
import { getSkipLink, acquireCluster } from '@/utils';
import LogoSvg from '@/assets/imgs/logo.svg';

const SwitchLang = loadable(() => import('@/components/switch-lang'), { fallback: null });

const Navbar: React.FC<{ onLangChange?: () => Promise<boolean> }> = ({ onLangChange }) => {
  const isTTP = acquireCluster() === 'ttp';

  const handleLogoClick = (): void => {
    if (isTTP) {
      window.location.href = getSkipLink();
    }
  };

  return (
    <div className={cx(styles.container, 'flex items-center justify-between')}>
      <img
        className={styles.logo}
        src={LogoSvg}
        alt="TikTok Shop"
        decoding="async"
        onClick={isTTP ? handleLogoClick : undefined}
        style={isTTP ? { cursor: 'pointer' } : undefined}
      />
      <SwitchLang onChange={onLangChange} />
    </div>
  );
};

export default Navbar;
